import React, { useMemo, useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import countryList from "react-select-country-list";
import authService from "../services/authservices";
import { UserContext } from "../contexts/UserContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

function Register() {
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [signloader, setSignloader] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const [termsOpen, setTermsOpen] = useState(false);

  // const [referralCode, setReferralCode] = useState("");
  const { user } = useContext(UserContext);
  const { theme } = useContext(UserContext);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const [isReferralFromUrl, setIsReferralFromUrl] = useState(false);
  useEffect(() => {
    let str = window.location.href;
    const letters = str.includes("?");

    if (letters) {
      let locationData = window.location.href.split("=")[1];

      if (locationData && locationData.length > 11) {
        locationData = locationData.substring(0, 11);
      }

      let formDataUrl = { ...formData, referralCode: locationData };
      setFormData(formDataUrl);
      setIsReferralFromUrl(true);
    }
  }, []);

  useEffect(() => {
    // Add a listener for navigation
    if (location.pathname !== "/verification") {
      sessionStorage.setItem("timerstatus", "false");
    }
  }, [location]);

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  const [formData, setFormData] = useState({
    email: "",
    country: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  const options = useMemo(() => countryList().getData(), []);

  const handleChange = (selectedOption) => {
    setValue(selectedOption);
    setFormData({ ...formData, country: selectedOption.label });

    // Clear the error for the country field if a valid country is selected
    let newErrors = { ...errors };
    if (selectedOption.label) {
      delete newErrors.country;
    }
    setErrors(newErrors);
  };

  const handleInputChangeCountry = (newInputValue) => {
    if (newInputValue.length <= 16) {
      setInputValue(newInputValue);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Individual field validation
    let newErrors = { ...errors };
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) newErrors.email = "Email is required";
      else if (!emailRegex.test(value))
        newErrors.email = "Invalid email format";
      else if (value.length > 250)
        newErrors.email = "Email cannot exceed 250 characters";
      else delete newErrors.email;
    } else if (name === "password") {
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&.]{8,30}$/;
      if (!value) newErrors.password = "Password is required";
      else if (!passwordRegex.test(value))
        newErrors.password =
          "Password must be at least 8 characters, include at least one letter, one number, and may contain @ $ ! % * ? & .";
      else delete newErrors.password;
    } else if (name === "confirmPassword") {
      if (!value) newErrors.confirmPassword = "Confirm Password is required";
      else if (value !== formData.password)
        newErrors.confirmPassword = "Passwords do not match";
      else delete newErrors.confirmPassword;
    } else if (name === "referralCode") {
      const referralCodeRegex = /^[a-zA-Z0-9]{1,13}$/;
      if (value && !referralCodeRegex.test(value))
        newErrors.referralCode =
          "Referral code must be alphanumeric and 1-13 characters long";
      else delete newErrors.referralCode;
    }

    setErrors(newErrors);
  };

  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, agree: e.target.checked });

    // Clear the error for the agree field if the checkbox is checked
    let newErrors = { ...errors };
    if (e.target.checked) {
      delete newErrors.agree;
    }
    setErrors(newErrors);
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&.]{8,30}$/;
    const referralCodeRegex = /^[a-zA-Z0-9]{1,13}$/;

    // console.log("formData reg --->>", formData, "newErrors --->>", newErrors);

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    } else if (formData.email.length > 250) {
      newErrors.email = "Email cannot exceed 250 characters";
    }

    if (!formData.country) {
      newErrors.country = "Country is required";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (!passwordRegex.test(formData.password)) {
      newErrors.password =
        "Password must be 8-30 characters long, include uppercase, lowercase, number, and special character";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (
      formData.referralCode &&
      !referralCodeRegex.test(formData.referralCode)
    ) {
      newErrors.referralCode =
        "Referral code must be alphanumeric and 1-13 characters long";
    }

    if (!formData.agree && termsOpen) {
      newErrors.agree = "You must agree to the terms and conditions";
    }

    return newErrors;
  };

  const handleKeyDown = (e, type) => {
    if (type === "email") {
      const regex = /^[a-zA-Z0-9@._-]+$/;
      if (
        !regex.test(e.key) ||
        (e.target.value.length >= 250 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    } else if (type === "password" || type === "confirmPassword") {
      if (
        e.key === " " ||
        (e.target.value.length >= 30 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    } else if (type === "referralCode") {
      const regex = /^[a-zA-Z0-9]*$/;
      if (
        !regex.test(e.key) ||
        (e.target.value.length >= 13 && e.key !== "Backspace")
      ) {
        // console.log("inviteCode enters 22222-->");
        e.preventDefault();
      }
    }
  };
  const registrationData = {
    ...formData,
    // referralCode: user?.referralCode || "", // Add the referral code if available
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };
  const handleSubmit = async (e) => {
    // console.log("register submit enters --->>>");
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      // Focus on the first invalid field and return immediately
      const firstErrorField = Object.keys(validationErrors)[0];
      const firstErrorElement = document.getElementsByName(firstErrorField)[0];
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
      return;
    }

    try {
      setSignloader(true); //button disabled
      // console.log("registrationData",registrationData);
      // return;
      // const registrationData = {
      //   ...formData,
      //   referralCode:
      //     new URLSearchParams(window.location.search).get("invite") || "", // Get referral code from URL
      // };
      const response = await authService.register(registrationData);
      setSignloader(false); //button enabled
      if (response.status) {
        setUser({ email: formData.email });
        showSuccessToast(response.Message);
        // setTimeout(() => {
        sessionStorage.setItem("timerstatus", "true");
        navigate("/verification");
        // }, 1000);
        setFormData({
          email: "",
          country: "",
          password: "",
          confirmPassword: "",
          referralCode: "",
          agree: false,
        });
        setValue(null);
        await handleTermsClose();
      } else {
        sessionStorage.setItem("timerstatus", "false");
        showErrorToast(response.Message);
        setFormData({
          email: "",
          country: "",
          password: "",
          confirmPassword: "",
          referralCode: "",
          agree: false,
        });
        setValue(null);
        await handleTermsClose();
      }
    } catch (error) {
      setSignloader(false); //button enabled
      showErrorToast("Something went wrong, please try again later.");
      setFormData({
        email: "",
        country: "",
        password: "",
        confirmPassword: "",
        referralCode: "",
        agree: false,
      });
      await handleTermsClose();
      setValue(null);
      console.error("Error during registration:", error);
    }
  };

  const navigatetoTerms = () => {
    window.open("/terms-of-service", "_blank");
  };

  const navigatetoPolicy = () => {
    window.open("/privacy-cookies-policy", "_blank");
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "50px",
      minHeight: "44px",
      backgroundColor: state.isFocused ? "#181a20" : "#181a20", // Background color on focus
      borderColor: state.isFocused ? "#2b3139" : "#2b3139", // Change border color on focus
      color: "#fff", // Text color
      boxShadow: state.isFocused ? "none" : "none", // Box-shadow on focus
      fontFamily: '"Helvetica", sans-serif', // Custom font family
      fontSize: "14px", // Custom font size
      padding: "0 8px",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#dfdede", // Hover border color
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px", // Ensure consistent height for the value container (selected value area)
      padding: "0 8px", // Padding inside the value container
    }),
    input: (provided) => ({
      ...provided,
      height: "50px", // Consistent height for input inside the select
      margin: "0", // Ensure the margin does not affect the height
      padding: "0", // Padding inside input
      color: theme === "dark" ? "#a5a0a0" : "#909090",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? theme === "dark"
          ? "#20a1fd "
          : "#20a1fd "
        : state.isFocused
        ? theme === "dark"
          ? "#333"
          : "#f0f0f0"
        : theme === "dark"
        ? "#181a20"
        : "#ffffff", // Background color for selected and hovered options
      color: state.isSelected ? "#000000" : "#fff", // Text color for selected option
      fontFamily: '"Helvetica", sans-serif',
      cursor: "pointer",
      margin: "0px",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#181a20" : "#ffffff", // Background of the dropdown menu
      borderColor: theme === "dark" ? "#444" : "#dfdede",
      borderRadius: "10px", // Custom border-radius for the dropdown menu
      overflow: "hidden",
      scrollbarWidth: "thin", // For Firefox
      scrollbarColor: theme === "dark" ? "#555 #222" : "#ccc #f9f9f9", // For Firefox
      "&::-webkit-scrollbar": {
        width: "8px", // Scrollbar width
      },
      "&::-webkit-scrollbar-track": {
        background: theme === "dark" ? "#222" : "#f9f9f9", // Scrollbar track color
      },
      "&::-webkit-scrollbar-thumb": {
        background: theme === "dark" ? "#555" : "#ccc", // Scrollbar thumb color
        borderRadius: "4px", // Rounded scrollbar thumb
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: theme === "dark" ? "#666" : "#aaa", // Hover color for the thumb
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#909090", // Color of the selected value
      fontFamily: '"Helvetica", sans-serif',
    }),
  };

  //   terms of service
  const handleTermsOpen = () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      const firstErrorField = Object.keys(validationErrors)[0];
      const firstErrorElement = document.getElementsByName(firstErrorField)[0];
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
      return;
    }
    setTermsOpen(true);
  };
  const handleTermsClose = () => {
    setTermsOpen(false);
    setErrors((prevErrors) => {
      const { agree, ...rest } = prevErrors;
      return rest;
    });
  };

  //   privacy and cookies policy
  const [cookiesOpen, setCookiesOpen] = useState(false);
  const handleCookiesOpen = () => setCookiesOpen(true);
  const handleCookiesClose = () => setCookiesOpen(false);

  return (
    <>
      <div className="container-fluid">
        <Link to="/">
          <img
            src={require("../assests/Logo.webp")}
            alt="Logo"
            className="cursor-pointer bn-login-logo"
          />
        </Link>

        <div className="row bn-login-row mx-0 g-4 mt-3">
          <div className="col-lg-6">
            <div className="d-flex flex-column">
              <div className="register_left_main ">
                <div className="hero_center">
                  <div className="register_form">
                    <span className="register_head_sign">{t("SignUp")}</span>
                    <form autoComplete="off">
                      <div className="register_inner_main">
                        <div className="register_inner_submain">
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("EmailAddress")}
                            </span>
                            <input
                              type="text"
                              name="email"
                              placeholder={t("EnterTheEmailAddress")}
                              className="reg_input"
                              value={formData.email}
                              onChange={handleInputChange}
                              onKeyDown={(e) => handleKeyDown(e, "email")}
                            />
                            {errors.email && (
                              <span className="error">{errors.email}</span>
                            )}
                          </div>

                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("Country")}
                            </span>
                            <Select
                              options={options}
                              value={value}
                              onChange={handleChange}
                              placeholder={t("SelectYourCountry")}
                              styles={customStyles}
                              className="register-country-dropdown"
                              name="random-country-select"
                              inputId="random-country-id"
                              autoComplete="new-country"
                              inputValue={inputValue}
                              onInputChange={handleInputChangeCountry}
                            />
                            {errors.country && (
                              <span className="error">{errors.country}</span>
                            )}
                          </div>

                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("Password")}
                            </span>
                            <div className="reg_pos_rel">
                              <input
                                type={passwordVisible ? "text" : "password"}
                                name="password"
                                placeholder={t("EnterThePassword")}
                                className="reg_input"
                                value={formData.password}
                                onChange={handleInputChange}
                                onKeyDown={(e) => handleKeyDown(e, "password")}
                                autoComplete="off"
                              />
                              <i
                                className={`fa-regular ${
                                  passwordVisible ? "fa-eye" : "fa-eye-slash"
                                } reg_eye`}
                                onClick={togglePasswordVisibility}
                              />
                            </div>
                            {errors.password && (
                              <span className="error">{errors.password}</span>
                            )}
                          </div>
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("ConfirmPassword")}
                            </span>
                            <div className="reg_pos_rel">
                              <input
                                type={
                                  confirmPasswordVisible ? "text" : "password"
                                }
                                name="confirmPassword"
                                placeholder={t("ReEnterThePassword")}
                                className="reg_input"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                onKeyDown={(e) =>
                                  handleKeyDown(e, "confirmPassword")
                                }
                                autoComplete="off"
                              />
                              <i
                                className={`fa-regular ${
                                  confirmPasswordVisible
                                    ? "fa-eye"
                                    : "fa-eye-slash"
                                } reg_eye`}
                                onClick={toggleConfirmPasswordVisibility}
                              />
                            </div>
                            {errors.confirmPassword && (
                              <span className="error">
                                {errors.confirmPassword}
                              </span>
                            )}
                          </div>
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("ReferralCode")}
                            </span>
                            <input
                              type="text"
                              name="referralCode"
                              placeholder={t("EnterTheReferralCode")}
                              className="reg_input"
                              maxLength="11"
                              disabled={isReferralFromUrl}
                              value={formData.referralCode}
                              onChange={handleInputChange}
                              onKeyDown={(e) =>
                                handleKeyDown(e, "referralCode")
                              }
                            />
                          </div>
                        </div>
                        <div className="getting_card_content">
                          {/* <div className="reg_check_main align-center">
                            <div class="checkbox-container">
                              <input
                                id="custom-checkbox"
                                type="checkbox"
                                className="input-field regular_checkbox"
                                checked={formData.agree}
                                onChange={handleCheckboxChange}
                              />
                              <label htmlFor="custom-checkbox"></label>
                            </div>
                            <span
                              htmlFor="custom-checkbox"
                              className="register_spans mt-1"
                            >
                              {t("IAgreeToThe")}
                              <span className="reg_check_span cursor-pointer">
                                {" "}
                                <span onClick={navigatetoTerms}>
                                  {t("Terms&Conditions")}
                                </span>{" "}
                                <span className="register-and-tag">
                                  {t("and")}
                                </span>{" "}
                                <span onClick={navigatetoPolicy}>
                                  {t("PrivacyPolicies")}
                                </span>
                              </span>
                            </span>
                          </div>
                          {errors.agree && (
                            <span className="error">{errors.agree}</span>
                          )} */}

                          {/* {signloader === true ? (
                            <div className="reg_btn">
                              <span className="hero_invest">
                                {" "}
                                {t("Loading")}{" "}
                              </span>
                            </div>
                          ) : (
                            <div className="reg_btn" onClick={handleSubmit}>
                              <span className="hero_invest">
                                {" "}
                                {t("SignUp")}{" "}
                              </span>
                            </div>
                          )} */}
                          <div className="reg_btn" onClick={handleTermsOpen}>
                            <span className="hero_invest"> {t("SignUp")} </span>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <span className="reg_bottom_span">
                    {t("AlreadyHaveAnAccount")}
                    <Link to="/login">
                      {" "}
                      <span className="reg_check_span">{t("LogIn")}.</span>{" "}
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 ">
            <div className="bn-login-right bn-reg-rgt">
              <h6 className="bn-log-rgt-title">{t("TradeStrong")}</h6>
              <p className="bn-log-rgt-content">{t("JoinUs")}</p>
            </div>
          </div>
        </div>

        {/* Terms of service popup */}
        <Modal
          keepMounted
          open={termsOpen}
          onClose={handleTermsClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style} className="hd_terms_box">
            <div className="hd_contact_box_inner">
              <div className="hd_terms_top">
                <h6>{t("BinargeTermsOfService")}</h6>
                <span onClick={handleTermsClose}>
                  <i className="fa-solid fa-xmark"></i>
                </span>
              </div>

              <div className="hd_terms_main">
                <div className="contentpage mt-3">
                  <h3>1. {t("Introduction")} </h3>
                  {/* <h4>NOTICE:</h4> */}

                  <p>{t("WelcomeToBinarge")}</p>

                  <h3>2. {t("ServiceDescription")}</h3>

                  <p>{t("CryptocurrencyTrading")}</p>

                  <h3>3. {t("UserEligibility")}</h3>
                  <p>{t("YouMustBeLeast")}</p>

                  <h3>4. {t("AccountAndSecurity")}</h3>
                  <p>{t("YouAreResponsible")} </p>

                  <h3>5. {t("APIConnections")}</h3>

                  <p>{t("BinargeOperates")}</p>

                  <h3>6. {t("Subscription")}</h3>
                  <p>{t("BinargeOffers")}</p>

                  <h3>7. {t("ProfitSharing")}</h3>
                  <p>{t("BinargeUses")}</p>

                  <h3>8. {t("RiskDisclaimer")}r</h3>
                  <p>{t("TradingCryptocurrencies")}</p>

                  <h3>9. {t("NoFinancialAdvice")}</h3>
                  <p>{t("FinanciaAdvisor")}</p>

                  <h3>10. {t("Termination")}</h3>
                  <p>{t("WeReserveTheRight")}</p>

                  <h3>11. {t("ChangesToTerms")}</h3>
                  <p>{t("BinargeMayRevise")}</p>

                  <h3>12. {t("ContactInformation")}</h3>
                  <p>{t("ForQuestions")}</p>
                  <div className="reg_check_main align-center">
                    <div class="checkbox-container">
                      <input
                        id="custom-checkbox"
                        type="checkbox"
                        className="input-field regular_checkbox"
                        checked={formData.agree}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="custom-checkbox"></label>
                    </div>
                    <span
                      htmlFor="custom-checkbox"
                      className="register_spans mt-1"
                    >
                      {t("IAgreeToThe")}
                      <span className="reg_check_span cursor-pointer">
                        {" "}
                        <span onClick={navigatetoTerms}>
                          {t("Terms&Conditions")}
                        </span>{" "}
                        <span className="register-and-tag">{t("and")}</span>{" "}
                        <span onClick={navigatetoPolicy}>
                          {t("PrivacyPolicies")}
                        </span>
                      </span>
                    </span>
                  </div>
                  {errors.agree && (
                    <span className="error">{errors.agree}</span>
                  )}
                  <div className="reg_btnsignup">
                    {signloader === true ? (
                      <div className="reg_btn">
                        <span className="hero_invest"> {t("Loading")} </span>
                      </div>
                    ) : (
                      <div className="reg_btn" onClick={handleSubmit}>
                        <span className="hero_invest"> {t("accept")} </span>
                      </div>
                    )}
                    <div className="reg_btn" onClick={handleTermsClose}>
                      <span className="hero_invest"> {t("decline")} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Register;
